












































































//@ts-ignore
// import NaijaStates from "naija-state-local-government";
import { db } from "@/firebase/firebase";
import { countries } from "@/store/hardData";
import { Project, Report } from "@/interfaces/interfaces";
import { useMainStore } from "@/store/storage";
import {
  computed,
  defineComponent,
  reactive,
  toRefs
} from "@vue/composition-api";
// import moment from "moment";
export default defineComponent({
  name: "ProjectList",
  setup(props, { root }) {
    const main = useMainStore();
    const state = reactive({
      formStatus: false,
      projects: [] as Project[],
      headers: [
        {
          text: " Project Name",
          value: "companyName",
          align: "start",
          sortable: true
        },
        {
          text: " Mobile",
          value: "mobile",
          align: "start",
          sortable: true
        },
        {
          text: " Email",
          value: "email",
          align: "start",
          sortable: true
        }
      ],
      activeItem: 0,
      search: ""
    });

    // const NigeriaInfo = reactive({
    //   NigeriaStates: NaijaStates.states(),
    //   NigeriaLGA: NaijaStates.lgas(main.state.projectData.state)
    // });

    // function clearStates() {
    //   main.state.projectData.state = "";
    //   NigeriaInfo.NigeriaLGA = NaijaStates.lgas(main.state.projectData.state);
    // }
    // function clearLGA() {
    //   NigeriaInfo.NigeriaLGA = NaijaStates.lgas(main.state.projectData.state);
    //   main.state.projectData.LGA = "";
    // }
    function resetProjectData() {
      main.resetProjectData();
    }

    function getReports(): void {
      if (main.state.projectData.id) {
        db.collection("projects")
          .doc(main.state.projectData.id as string)
          .collection("reports")
          .orderBy("inspectionArea")
          // .onSnapshot((snapshot) => {
          .get()
          .then((snapshot) => {
            const reports = [] as Report[];
            snapshot.forEach((item) => {
              reports.push({ ...item.data(), id: item.id } as Report);
            });
            main.state.reports = reports;
          });
      }
    }

    async function setItem(item: Project) {
      console.log("setItem -> main.state.projectData", main.state.projectData)
      const oldProjectId = main.state.projectData.id;
      main.state.projectData = item;
      main.state.projectId = item.id as string;

      if (item.id !== oldProjectId) {
        await getReports();
        console.log("setItem ->   main.state.projectId ", item, main.state.projectData, main.state.reports);
      }
    }

    function removeItem(item: Project) {
      if (confirm("Are you sure you want to permanently delete this record?")) {
        if (item.id) {
          db.collection("projects")
            .doc(item.id)
            .delete();
          main.resetProjectData();
        }
      }
    }

    const projectsClientFiltered = computed(() => {

      console.log("projectsClientFiltered -> main.state.projects", main.state.projects)

      return main.state.projects.filter((item) => {
        // console.log(
        //   "projectsFiltered ->  main.state.clientData.id",
        //   main.state.clientData.id,
        //   item.id
        // );
        return main.state.clientData.id === item.clientId;
      });
    });

    const projectsFiltered = computed(() => {
      return projectsClientFiltered.value.filter((item) => {
        if (state.search !== "") {
          return item.name.toLowerCase().includes(state.search);
        } else {
          return true;
        }
      });
    });

    // console.log("projectsFiltered -> projectsFiltered", projectsFiltered);

    function addProject() {
      root.$emit("showprojectform", true);
      // main.resetProjectData;
      main.state.projectData.clientId = main.state.clientData.id as string;
      main.state.projectData.id = '' as string;

    }

    return {
      mainStore: main,
      mainState: main.state,
      resetform: main.resetProjectData,
      projectsFiltered,
      ...toRefs(state),
      // ...toRefs(NigeriaInfo),
      countries,
      // clearStates,
      // clearLGA,
      resetProjectData,
      setItem,
      removeItem,
      addProject
    };
  }
});
